export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { slug: "lianai", name: "恋爱", icon: "ri-heart-line", description: "甜蜜浪漫的恋爱故事，霸道总裁、契约婚姻、姐弟恋应有尽有" },
  { slug: "qihuan", name: "奇幻", icon: "ri-magic-line", description: "剑与魔法、龙与骑士、异世界冒险，带您进入想象力的王国" },
  { slug: "dongzuo", name: "动作", icon: "ri-sword-line", description: "热血战斗、武道巅峰、燃爆肾上腺素的刺激对决" },
  { slug: "juqing", name: "剧情", icon: "ri-film-line", description: "感人至深的故事，穿越、重生、治愈，触动人心的情感佳作" },
  { slug: "gaoxiao", name: "搞笑", icon: "ri-emotion-laugh-line", description: "欢乐搞笑、轻松愉快，让您笑到停不下来的欢乐漫画" },
  { slug: "xuanyi", name: "悬疑", icon: "ri-search-eye-line", description: "扣人心弦的推理故事，神秘案件、惊悚氛围、反转不断" },
  { slug: "xiaoyuan", name: "校园", icon: "ri-building-line", description: "青春校园、纯爱故事，带您重返最美好的学生时代" },
  { slug: "gufeng", name: "古风", icon: "ri-ancient-gate-line", description: "宫廷权谋、江湖恩怨、仙侠传说，唯美国风的视觉盛宴" },
];

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find(c => c.slug === slug);
}